module.exports = __webpack_public_path__ + "img/Powered_by_StandApp.559e4fb5.svg";